(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .controller('AppraisalOrderAssignController', AppraisalOrderAssignController);

    AppraisalOrderAssignController.$inject = ['$mdDialog', 'order', 'assignType', 'AppraisalOrder', 'AppraisalOrderModal', 'AppraiserUser', 'suggestedAppraisers', 'eligibleAppraisers', 'independentAppraisers', 'Principal', 'AlertService'];

    function AppraisalOrderAssignController ($mdDialog, order, assignType, AppraisalOrder, AppraisalOrderModal, AppraiserUser, suggestedAppraisers, eligibleAppraisers, independentAppraisers, Principal, AlertService) {
        var vm = this;
        vm.suggestedAppraisers = suggestedAppraisers;
        vm.eligibleAppraisers = eligibleAppraisers;
        vm.independentAppraisers = independentAppraisers;
        vm.currentAppraiser = order.assignedAppraiserId ? AppraiserUser.get({id: order.assignedAppraiserId}) : null;
        vm.matchAppraisers = matchAppraisers;
        vm.getSuggestedAppraiserText = getSuggestedAppraiserText;
        vm.getAppraiserText = getAppraiserText;
        vm.assignType = assignType;
        vm.save = save;
        vm.cancel = cancel;
        vm.isSaving = false;

        vm.isAppraisalFirm = Principal.hasAnyAuthority([/^ROLE_(APPRAISAL).*/i]);
        vm.isVCEmployee = Principal.hasAnyAuthority([/^ROLE_(ADMIN|CUSTOMER_CARE_REPRESENTATIVE|VC_.*)$/i]);
        vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);
        vm.filterNotNull = filterNotNull;
        vm.hasAssignSelection = hasAssignSelection;

        // Partial Lender Coverage (admins only): suggested appraisers per lender on a multi-lender order.
        // The section shows, closed, as soon as the dialog opens; its data loads one page at a time behind it.
        vm.showLenderCoverage = vm.isAdmin && countPotentialLenders(order) > 1;
        vm.isPartialCoverageOpen = false;
        vm.isCoverageLoading = false;
        vm.hasCoverageLoaded = false;
        vm.hasCoverageError = false;
        vm.lenderCoverage = [];
        vm.coverageRows = [];
        vm.coverageTotal = 0;
        vm.coveredLenderCount = 0;
        vm.coveragePage = 1;
        vm.coveragePageSize = 10;
        vm.loadCoveragePage = loadCoveragePage;

        // Regional Coverage (admins and CSRs): appraisers who service the region and meet the order's other
        // requirements, ignoring lender approval. Market rent orders are not region-bound, so it is hidden there.
        vm.showRegionalCoverage = Principal.hasAnyAuthority([/^ROLE_(ADMIN|CUSTOMER_CARE).*/i])
            && order.appraisalTypeOptions !== 'AUTOMATED_MARKET_RENT_REPORT';
        vm.isRegionalCoverageOpen = false;
        vm.isRegionalLoading = false;
        vm.hasRegionalLoaded = false;
        vm.hasRegionalError = false;
        vm.regionalRows = [];
        vm.regionalTotal = 0;
        vm.regionalPage = 1;
        vm.regionalPageSize = 10;
        vm.loadRegionalPage = loadRegionalPage;

        // Quote request recipients ticked in either coverage table, by appraiser id; kept across pages.
        // The source is the table the tick was made in, so Quote Requests can list each table separately.
        vm.quoteRequestChecked = {};
        vm.quoteRequestAppraisers = {};
        vm.quoteRequestSource = {};
        vm.toggleQuoteRequestRecipient = toggleQuoteRequestRecipient;
        vm.quoteRequestCount = quoteRequestCount;
        vm.openQuoteRequest = openQuoteRequest;
        vm.showQuoteRequestButton = vm.showLenderCoverage || vm.showRegionalCoverage;
        vm.hasAnyCoverageLoaded = hasAnyCoverageLoaded;
        vm.isAnyCoverageLoading = isAnyCoverageLoading;
        vm.hasAllCoverageFailed = hasAllCoverageFailed;

        if (vm.showLenderCoverage) {
            loadCoveragePage();
        }
        if (vm.showRegionalCoverage) {
            loadRegionalPage();
        }

        // Remove the current appraiser (if any) from the list of appraisers
        if(order.assignedAppraiserId) {
            vm.suggestedAppraisers.$promise.then(function(appraisers) {
                var currentAppraiserId = order.assignedAppraiserId;
                vm.suggestedAppraisers = appraisers.filter(function(appraiser) {
                    return appraiser.id !== currentAppraiserId;
                });
            });

            vm.eligibleAppraisers.$promise.then(function(appraisers) {
                var currentAppraiserId = order.assignedAppraiserId;
                vm.eligibleAppraisers = appraisers.filter(function(appraiser) {
                    return appraiser.id !== currentAppraiserId;
                });
            });
        }

        function getSuggestedAppraiserText(item) {
            var textStrArray = [];
            // User Full Name
            textStrArray.push(item.userFullName);

            if (!vm.isAppraisalFirm) {
                // (Firm Assistant Name)
                if (item.appraisalFirmAssistantName) {
                    textStrArray.push('(' + item.appraisalFirmAssistantName + ')');
                }
                // Firm Name
                textStrArray.push('|');
                textStrArray.push(item.appraisalFirmName);
            }

            if (item.isFirmRostered) {
                textStrArray.push('| Rostered');
            }

            if (item.isFirmIndependent) {
                textStrArray.push('| Independent');
            }

            return textStrArray.join(' ');
        }

        function getAppraiserText(item) {
            var text = item.userFullName + " | " + item.appraisalFirmName;
            item.regions.forEach(function(region) {
                text += ", " + region.name;
            });

            if (item.isFirmRostered) {
                text += (' | Rostered ');
            }

            if (item.isFirmIndependent) {
                text += (' | Independent ');
            }

            return text;
        }

        function matchAppraisers(searchText, appraisers) {
            var searchRegex = new RegExp(searchText, 'gi');
            return appraisers.filter(function(appraiser) {
                var name = getAppraiserText(appraiser);
                return searchRegex.test(name);
            });
        }

        function countPotentialLenders(appraisalOrder) {
            var option = (appraisalOrder.options || []).find(function(o) {
                return o.name === 'PLACEHOLDER_LENDER';
            });
            if (!option || !option.value) {
                return 0;
            }
            var potentialLenders = JSON.parse(option.value).potentialLenders;
            return potentialLenders ? potentialLenders.length : 0;
        }

        function loadCoveragePage() {
            vm.isCoverageLoading = true;
            return AppraiserUser.getLenderCoverage({id: order.id, page: vm.coveragePage - 1, size: vm.coveragePageSize}).$promise
                .then(function(result) {
                    vm.lenderCoverage = result.lenders;
                    vm.coverageTotal = result.totalRows;
                    vm.hasCoverageLoaded = true;
                    vm.coveredLenderCount = result.lenders.filter(function(lender) {
                        return lender.appraiserCount > 0;
                    }).length;
                    // Look up "is this lender covered" by id in the template
                    vm.coverageRows = result.rows.map(function(row) {
                        var covered = {};
                        row.coveredLenderIds.forEach(function(lenderId) {
                            covered[lenderId] = true;
                        });
                        return {appraiser: row.appraiser, covered: covered, declined: row.declined, firmDeclined: row.firmDeclined};
                    });
                })
                .catch(function() {
                    vm.hasCoverageError = !vm.hasCoverageLoaded;
                    AlertService.error('Could not load lender coverage.');
                })
                .finally(function() {
                    vm.isCoverageLoading = false;
                });
        }

        function loadRegionalPage() {
            vm.isRegionalLoading = true;
            return AppraiserUser.getRegionalCoverage({id: order.id, page: vm.regionalPage - 1, size: vm.regionalPageSize}).$promise
                .then(function(result) {
                    vm.regionalRows = result.rows;
                    vm.regionalTotal = result.totalRows;
                    vm.hasRegionalLoaded = true;
                })
                .catch(function() {
                    vm.hasRegionalError = !vm.hasRegionalLoaded;
                    AlertService.error('Could not load regional coverage.');
                })
                .finally(function() {
                    vm.isRegionalLoading = false;
                });
        }

        // @param source - 'partial' or 'regional', the table the tick was made in
        function toggleQuoteRequestRecipient(appraiser, source) {
            if (vm.quoteRequestChecked[appraiser.id]) {
                vm.quoteRequestAppraisers[appraiser.id] = appraiser;
                vm.quoteRequestSource[appraiser.id] = source;
            } else {
                delete vm.quoteRequestChecked[appraiser.id];
                delete vm.quoteRequestAppraisers[appraiser.id];
                delete vm.quoteRequestSource[appraiser.id];
            }
        }

        function quoteRequestCount() {
            return Object.keys(vm.quoteRequestAppraisers).length;
        }

        function hasAnyCoverageLoaded() {
            return (vm.showLenderCoverage && vm.hasCoverageLoaded) || (vm.showRegionalCoverage && vm.hasRegionalLoaded);
        }

        function isAnyCoverageLoading() {
            return (vm.showLenderCoverage && !vm.hasCoverageLoaded && !vm.hasCoverageError)
                || (vm.showRegionalCoverage && !vm.hasRegionalLoaded && !vm.hasRegionalError);
        }

        function hasAllCoverageFailed() {
            return (!vm.showLenderCoverage || vm.hasCoverageError) && (!vm.showRegionalCoverage || vm.hasRegionalError);
        }

        // Close this dialog, then open Quote Requests with the ticked appraisers as recipients, one list per table
        function openQuoteRequest() {
            var partialRecipients = [];
            var regionalRecipients = [];
            Object.keys(vm.quoteRequestAppraisers).forEach(function(id) {
                var recipients = vm.quoteRequestSource[id] === 'regional' ? regionalRecipients : partialRecipients;
                recipients.push(vm.quoteRequestAppraisers[id]);
            });
            $mdDialog.cancel({
                followUp: function() {
                    return AppraisalOrderModal.quoteRequests(order, partialRecipients, regionalRecipients);
                }
            });
        }

        function hasAssignSelection() {
            return filterNotNull([vm.selectedAppraiser, vm.selectedAppraiserOther, vm.selectedAppraiserIndependent]).length > 0;
        }

        function filterNotNull(values) {
            return values.filter(function (value) {
                return value != null
            });
        }

        function save() {
            let selectedAppraiser = null;

            let possibleSelections = [vm.selectedAppraiser, vm.selectedAppraiserOther, vm.selectedAppraiserIndependent]
            if (filterNotNull(possibleSelections).length === 0) {
                AlertService.error("One appraiser must be selected");
                return;
            } else if (filterNotNull(possibleSelections).length !== 1) {
                AlertService.error("Only one appraiser can be assigned at a time");
                return;
            } else {
                selectedAppraiser = filterNotNull(possibleSelections)[0]
            }

            vm.isSaving = true;
            if (vm.assignType === "PREASSIGN_APPRAISER") {
                AppraisalOrder.preassignAppraiser({id: order.id, appraiserId: selectedAppraiser.id}, null, onSuccess, onError);
            } else if (vm.assignType === "ASSIGN_APPRAISER"
                        || !order.assignedAppraiserId) {
                AppraisalOrder.assignAppraiser({id: order.id, appraiserId: selectedAppraiser.id}, null, onSuccess, onError);
            } else {
                if(selectedAppraiser.appraisalFirmLocationId !== order.assignedAppraiser.appraisalFirmLocationId) {
                    var confirm = $mdDialog.confirm({skipHide: true})
                        .title('Selected Appraiser From Different Firm')
                        .textContent('Are you sure you want to send the order to a different firm? Any data entered in the report builder will be permanently lost.')
                        .ariaLabel('Selected Appraiser From Different Firm')
                        .ok('Yes')
                        .cancel('No');

                    $mdDialog.show(confirm)
                        .then(function () {
                            AppraisalOrder.reassignAppraiser({
                                id: order.id,
                                appraiserId: selectedAppraiser.id
                            }, null, onSuccess, onError);
                        })
                        .catch(function () {
                            vm.isSaving = false;
                        });
                }else{
                    AppraisalOrder.reassignAppraiser({
                        id: order.id,
                        appraiserId: selectedAppraiser.id
                    }, null, onSuccess, onError);
                }

            }

            function onSuccess(response) {
                vm.isSaving = false;
                $mdDialog.hide(response);
            }

            function onError(err) {
                vm.isSaving = false;
                $mdDialog.cancel({ error: "An error occurred while assigning the appraiser."});
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
